import * as React from 'react'

import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

function hydrate() {
  React.startTransition(() => {
    hydrateRoot(document, <HydratedRouter />)
  })
}

if (window.requestIdleCallback) {
  window.requestIdleCallback(hydrate)
} else {
  window.setTimeout(hydrate, 1)
}
